import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { UserServiceA2P } from '../services/userA2P.service';
import { SessionService } from '../services/session.service';
import { ValidarCodA2P } from '../entities/validarCodA2P.entity';
import { AlertBoxComponent } from '../shared/alertbox.component';
import { Respuesta } from '../entities/respuesta.entity';
import { UserService } from '../services/user.service';
import { Login } from '../entities/login.entity';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-valCodA2P-modal',
  templateUrl: './valCodA2P.component.html',
  styleUrls: ['./valCodA2P.component.css'] // usa el CSS anterior
})

export class ValCodA2PComponent implements OnInit {

  constructor(private userService: UserService, private sessionService: SessionService, private userServiceA2P: UserServiceA2P, private httpService: HttpService) { }

  @Input() title = 'Validar código';
  @Input() length = 6;
  @Input() ariaLabel = 'Validación de código';
  @Input() login: Login;
  @Input() explotacion: string;
  @Input() telefono: string;

  @Output() closeModal = new EventEmitter<void>();
  @Output() submitModal = new EventEmitter<void>();
  @Output() reSendCode = new EventEmitter<void>();

  public controls: FormControl[] = [];
  public resultado: Respuesta;
  public texto = '';
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  private timerMessage: any = null;
  public canInteract = false;
  public hideBody = false;
  private intentos: number = 0;

  public ngOnInit() {
    this.controls = Array.from({ length: this.length }, () => new FormControl('', Validators.maxLength(1)));
    this.texto = 'Hemos enviado un código a tu número ' + (this.formatTelefono(this.telefono)) + '. Por favor, introdúcelo.';
  }

  formatTelefono(telefono: string): string {
    if (!telefono) return '';

    const repeticiones = Math.max(telefono.length - 4, 0);
    return '*'.repeat(repeticiones) + telefono.slice(-4);
  }

  get code(): string {
    return this.controls.map(c => (c.value || '').toString().trim()).join('');
  }

  public onInput(i: number) {
    const ctrl = this.controls[i];
    let val: string = (ctrl.value || '').toString();
    val = val.replace(/\D/g, '');
    if (val.length > 1) val = val.charAt(0);
    ctrl.setValue(val, { emitEvent: false });
    if (val && i < this.controls.length - 1) {
      const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
      const next = inputs[i + 1];
      if (next)
        next.focus();
    }
    this.completedCode();
  }

  public onKeydown(event: KeyboardEvent, i: number) {
    const allowed =
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'Tab' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      /^[0-9]$/.test(event.key);

    if (!allowed) {
      event.preventDefault();
      return;
    }

    if (event.key === 'Backspace' && !this.controls[i].value && i > 0) {
      const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
      const prev = inputs[i - 1];
      if (prev)
        prev.focus();
    }
  }

  public handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    let text = '';
    if (event.clipboardData && typeof event.clipboardData.getData === 'function') {
      text = event.clipboardData.getData('text') || '';
    } else {
      const w = window as any;
      if (w.clipboardData && typeof w.clipboardData.getData === 'function') {
        text = w.clipboardData.getData('Text') || '';
      }
    }
    const digits = text.replace(/\D/g, '').slice(0, this.controls.length);

    for (let i = 0; i < this.controls.length; i++) {
      const d = digits[i] || '';
      this.controls[i].setValue(d, { emitEvent: false });
    }
    const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
    const last = inputs.item(this.controls.length - 1);
    if (last) {
      last.focus();
    }
    this.completedCode();
  }

  private completedCode(): void {
    const filledCount = this.controls.filter(c => /^\d$/.test((c.value || '').toString())).length;
    const completed = filledCount === this.controls.length;
    this.canInteract = completed;
  }

  public submit() {
    if (this.code.length < this.length) return;

    this.userServiceA2P.validarCodSMS(this.code).subscribe(
      response => this.validCodOnSuccess(response),
      response => this.validCodOnError(response)
    );
  }

  private validCodOnError(response: any) {

    this.resultado = response;
    var menssage = 'Codigo Inválido';

    if (this.resultado.Ex !== undefined) {
      menssage = this.resultado.Ex.Message;
    }
    this.showMessage(menssage, 'error');
  }

  private validCodOnSuccess(response: any) {
    this.showMessage("Codigo Validado Correctamente.", 'success');
  }

  public close() {
    this.closeModal.emit();
  }

  private showMessage(message: string, type: 'success' | 'error') {
    if (this.timerMessage) {
      clearTimeout(this.timerMessage);
      this.timerMessage = null;
    }

    if (type === 'success') {
      this.successMessage = message;
      this.hideBody = true;
      this.httpService.showSpinner();
    } else {
      this.errorMessage = message;
      this.intentos += 1;
      if (this.intentos == this.sessionService.intentosCodigo)
        this.errorMessage = this.errorMessage + ". Se han superado el numero de intentos.";
    }

    this.timerMessage = setTimeout(() => {
      this.successMessage = null;
      this.errorMessage = null;
      this.timerMessage = null;
      if (type === 'success') {
        this.submitModal.emit();
      } else {
        if (this.intentos == this.sessionService.intentosCodigo) {
          this.closeModal.emit();
        }
      }
    }, 3000);
  }

  public reSendCodeClick() {
    this.reSendCode.emit();
  }
  public ngOnDestroy(): void {
    if (this.timerMessage) {
      clearTimeout(this.timerMessage);
    }

    this.intentos = 0;
    this.controls = [];
    this.errorMessage = null;
    this.successMessage = null;
    this.texto = '';
    this.resultado = undefined as any;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/valCodA2P.component.ts